import React from "react";
import SectionTitle from "../../components/section-title";
import CSRImageContainer from "./csr-img/first";
import CSRImageContainertwo from "./csr-img/second";
import PropTypes from "prop-types";

const CSRContainer = ({ contRef, classOption }) => {
    return (
        <div
        // className={`service-section position-relative ${classOption}`}
        // ref={contRef}
        >
            <div className="blog-section g-background-color pb-10 pt-5">
                <div
                    className="section-title text-center"
                    style={{ marginTop: 50, paddingTop: 0 }}
                >
                    <div className="section-title text-center">
                        <h2 className="text-primary">
                            <b>Driving Women Empowerment</b>
                        </h2>
                    </div>
                </div>
                <div className="container">
                    <div className="b-color text-center">
                        <p>
                            NeoShakti by NeoGrowth is a CSR initiative dedicated
                            to empowering women to enable them to earn their
                            livelihood. Acknowledging the unique challenges they
                            face, such as limited resources, gender bias, and
                            societal barriers, NeoShakti works to bridge these
                            gaps.
                        </p>
                        <p>
                            The initiative focuses on providing women with
                            access to training and employment opportunities
                            fostering their growth and self-reliance. By
                            championing womens empowerment, NeoShakti strives to
                            drive inclusive economic growth and contribute to a
                            more equitable society.
                        </p>
                    </div>
                </div>
            </div>

            <div className="blog-section w-background-color mb-10 pt-5">
                <div className="section-title text-center">
                    <h2 className="text-primary">
                        <b>Major Focus Areas</b>
                    </h2>
                </div>
                <br></br>

                <div className="container py-5">
                    <div className="row justify-content-center">
                        <div className="col-lg-5 col-md-6 mb-4 d-flex justify-content-center">
                            <div
                                className="blog-card w-100"
                                style={{ minHeight: "100px" }}
                            >
                                <div className="blog-content text-center d-flex align-items-center justify-content-center h-100">
                                    <p
                                        className="title mb-0"
                                        style={{
                                            fontFamily:
                                                '"Open Sans", sans-serif',
                                        }}
                                    >
                                        Skill Development & Enabling Livelihood
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-5 col-md-6 mb-4 d-flex justify-content-center">
                            <div
                                className="blog-card w-100"
                                style={{ minHeight: "100px" }}
                            >
                                <div className="blog-content text-center d-flex align-items-center justify-content-center h-100">
                                    <p
                                        className="title mb-0"
                                        style={{
                                            fontFamily:
                                                '"Open Sans", sans-serif',
                                        }}
                                    >
                                        Workforce Participation
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <CSRImageContainer />
            <CSRImageContainertwo />

            <div className="container">
                <div className="w-100" style={{ maxWidth: "1200px" }}>
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-center p-4 bg-white">
                        {/* <div className="d-flex flex-column align-items-start mb-4 mb-md-0">
                            <a
                                href="/pdf/csr/COMPOSITION_OF_BOARD_COMMITTEES.pdf"
                                target="_blank"
                                className="btn btn-primary mb-5"
                                style={{ minWidth: "320px" }}
                            >
                                Our CSR Committee
                            </a>
                            <a
                                href="/pdf/csr/Corporate_Social_Responsibility_Policy.pdf"
                                target="_blank"
                                className="btn btn-primary mb-5"
                                style={{ minWidth: "320px" }}
                            >
                                Our CSR Policy
                            </a>
                            <a
                                href="/pdf/csr/Board_Approved_CSR_Projects.pdf"
                                target="_blank"
                                className="btn btn-primary"
                                style={{ minWidth: "320px" }}
                            >
                                Board Approved Projects
                            </a>
                        </div> */}

                        <ul className="d-flex flex-column align-items-start mb-4 mb-md-0 list-unstyled">
                            <li>
                                <a
                                    href="/pdf/csr/COMPOSITION_OF_BOARD_COMMITTEES.pdf"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-primary mb-5"
                                    style={{ minWidth: "320px" }}
                                >
                                    Our CSR Committee
                                </a>
                            </li>

                            <li>
                                <a
                                    href="/pdf/csr/Corporate_Social_Responsibility_Policy.pdf"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-primary mb-5"
                                    style={{ minWidth: "320px" }}
                                >
                                    Our CSR Policy
                                </a>
                            </li>

                            <li>
                                <a
                                    href="/pdf/csr/Board_Approved_CSR_Projects.pdf"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-primary"
                                    style={{ minWidth: "320px" }}
                                >
                                    Board Approved Projects
                                </a>
                            </li>
                        </ul>

                        <div className="text-center col-md-7">
                            <img
                                src="/images/csr/csr.jpg"
                                alt=""
                                style={{
                                    width: "auto",
                                    height: "auto",
                                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                                    borderRadius: "20px",
                                }}
                            />
                        </div>
                    </div>
                    <br></br>
                </div>
            </div>
        </div>
    );
};

CSRContainer.propTypes = {
    classOption: PropTypes.string,
    contRef: PropTypes.string,
};

CSRContainer.defaultProps = {
    classOption: "section-pb",
};

export default CSRContainer;
